import { jsx } from "react/jsx-runtime";
import React from "react";
import { ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import "./ToastRoot.scss";
export default function ToastRoot() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/dashboard")) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    ToastContainer,
    {
      className: "toast-container",
      toastClassName: "toast",
      autoClose: 5e3,
      closeOnClick: true,
      position: "top-center"
    }
  );
}
